/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslations } from "next-intl";
import Pdf from "@/components/pdf";
import { Link } from '@/providers/i18n/navigation';
import { Download } from "__barrel_optimize__?names=Download!=!lucide-react";
const files = {
    'video-sentinel-series-servers': '/files/Video Sentinel Brochure_compressed.pdf',
    'video-management-software': '/files/ionosphere Brochure_compressed.pdf',
    'isap-access': '/files/Access Control Brochure_compressed.pdf'
};
export default function ProductCatalogue(param) {
    let { maxWidth, slug } = param;
    // constants
    const file = files[slug];
    if (!file) return null;
    // hooks
    const T = useTranslations();
    return /*#__PURE__*/ _jsxs("div", {
        className: 'flex flex-col gap-8 items-center',
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: 'flex w-full items-center justify-between',
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: 'text-lg md:text-xl font-bold',
                        children: T('product_catalogue')
                    }),
                    /*#__PURE__*/ _jsxs(Link, {
                        href: file,
                        target: "_blank",
                        className: 'text-primary dark:text-dark-primary text-lg md:text-xl font-bold flex gap-4 items-center',
                        children: [
                            T('download'),
                            /*#__PURE__*/ _jsx(Download, {
                                size: 20
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: 'rounded-2xl w-full overflow-hidden',
                style: {
                    maxWidth
                },
                id: 'pdf-container-div',
                children: /*#__PURE__*/ _jsx(Pdf, {
                    container: 'pdf-container-div',
                    src: file
                })
            })
        ]
    });
}
